(() => {
  'use strict';
  const menu = document.querySelector('.mc-shop-menu');
  if (menu) {
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  }
  const store = document.querySelector('[data-mc-store]');
  if (!store) return;
  const groups = [...store.querySelectorAll('[data-store-group]')];
  const links = [...store.querySelectorAll('[data-store-brand]')];
  function reveal(hash, focus) {
    const key = hash.replace('#mc-shop-', '');
    const known = groups.some(group => group.dataset.storeGroup === key);
    const active = key === 'cremosa' ? 'cargolet' : (key === 'all' || known ? key : store.dataset.storeDefault || 'all');
    groups.forEach(group => { group.hidden = active !== 'all' && group.dataset.storeGroup !== active; });
    links.forEach(link => {
      if (link.dataset.storeBrand === active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    const target = document.getElementById(hash.slice(1));
    if (target && store.contains(target) && (focus || key === 'cremosa')) {
      target.scrollIntoView({block:'start', behavior:'auto'});
      if (focus) target.querySelector('h2')?.focus({preventScroll:true});
    }
  }
  links.forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    const hash = new URL(link.href).hash;
    history.pushState(null, '', location.pathname + location.search + hash);
    reveal(hash, true);
  }));
  window.addEventListener('popstate', () => reveal(location.hash, false));
  window.addEventListener('hashchange', () => reveal(location.hash, true));
  reveal(location.hash, false);
})();

